import moment from 'moment-timezone';
import { createSelector } from 'reselect';
import {
    ORDERS_TYPE_ALL,
    ORDERS_TYPE_FAVORITE
} from './actions';
import { sortByOrderNumber, getSorterByField } from './../orderSorters';

const stable = require('stable');

const getOrderList = {
    [ORDERS_TYPE_ALL]: state => state.ordersFind.numbers.map(number => state.orders[number]),
    [ORDERS_TYPE_FAVORITE]: state => state.ordersFind.numbers.map(number => state.orders[number]).filter(order => order.is_favorite),
}

const getFilter = {
    [ORDERS_TYPE_ALL]: state => state.ordersFind.filter[ORDERS_TYPE_ALL],
    [ORDERS_TYPE_FAVORITE]: state => state.ordersFind.filter[ORDERS_TYPE_FAVORITE],
}

const getSorting = state => state.ordersFind.sorting;

const getOrderSubjects = state => state.settings.orderSubjects || [];
const getOrderTypes = state => state.settings.orderTypes || [];
const getMySubjects = state => state.user.subjects || [];

export const getOrdersFind = {
    [ORDERS_TYPE_ALL]: createSelector([getOrderList[ORDERS_TYPE_ALL]], orderList => orderList),
    [ORDERS_TYPE_FAVORITE]: createSelector([getOrderList[ORDERS_TYPE_FAVORITE]], orderList => orderList),
};

export const getOrdersFindCounts = createSelector(
    [getOrderList[ORDERS_TYPE_ALL]],
    orderList => {
        return {
            all: orderList.length,
            favorite: orderList.filter(order => order.is_favorite).length,
        }
    }
);

const subjectsCounter = (orderSubjects, orderList) => orderSubjects.map(orderSubject => ({
    name: orderSubject,
    count: orderList.filter(order => (new RegExp(orderSubject, 'i')).test(order.subject)).length
}));
export const getOrdersSubjectsWithCount = {
    [ORDERS_TYPE_ALL]: createSelector([getOrderSubjects, getOrderList[ORDERS_TYPE_ALL]], subjectsCounter),
    [ORDERS_TYPE_FAVORITE]: createSelector([getOrderSubjects, getOrderList[ORDERS_TYPE_FAVORITE]], subjectsCounter),
};

const typesCounter = (orderTypes, orderList) => orderTypes.map(orderType => ({
    name: orderType,
    count: orderList.filter(order => (new RegExp(orderType, 'i')).test(order.type)).length
}));
export const getOrdersTypesWithCount = {
    [ORDERS_TYPE_ALL]: createSelector([getOrderTypes, getOrderList[ORDERS_TYPE_ALL]], typesCounter),
    [ORDERS_TYPE_FAVORITE]: createSelector([getOrderTypes, getOrderList[ORDERS_TYPE_FAVORITE]], typesCounter),
};

const filterByTime = (filterTime, orderList) => {
    if (filterTime === 'new') {
        return orderList.filter(order => !order.is_viewed);
    }
    const stamp = moment();
    switch (filterTime) {
        case '3hours': {
            stamp.subtract(3, 'hours');
            break;
        }
        case '5hours': {
            stamp.subtract(5, 'hours');
            break;
        }
        case '12hours': {
            stamp.subtract(12, 'hours');
            break;
        }
        case '24hours': {
            stamp.subtract(24, 'hours');
            break;
        }
        case 'yesterday': {
            stamp.startOf('day').subtract(1, 'day');
            break;
        }
        case 'lastWeek': {
            stamp.startOf('week');
            break;
        }
        default:
            return orderList;
    }
    return orderList.filter(item => moment(item.available_from).isSameOrAfter(stamp));
};
const filterBySubject = (filterSubject, orderList) => {
    return !filterSubject.length ? orderList : orderList.filter(order => filterSubject.some(filterItem => (new RegExp(filterItem, 'i')).test(order.subject)));
};
const filterByType = (filterType, orderList) => {
    return !filterType.length ? orderList : orderList.filter(order => filterType.some(filterItem => (new RegExp(filterItem, 'i').test(order.type))));
};
const filterByGroup = (filterGroup, orderList) => {
    return !filterGroup ? orderList : orderList.filter(order => order.writer_group === filterGroup);
};
const filterByPrice = (priceMin, priceMax, orderList) => orderList.filter(item => item.pregrader_price >= priceMin && item.pregrader_price <= priceMax);
const filterBySearch = (filterSearch, orderList) => !filterSearch ? orderList : orderList.filter(item => item.number.toLowerCase().indexOf(filterSearch.toLowerCase()) > -1);
const ordersFiltererSorter = (filter, sorting, mySubjects, orderList) => {
    let orders;
    if (!!filter.search) {
        orders = filterBySearch(filter.search, orderList);
    }
    else {
        orders = filterByTime(filter.time, orderList);
        orders = filterBySubject(filter.subject, orders);
        orders = filterByType(filter.type, orders);
        orders = filterByGroup(filter.group, orders);
        orders = filterByPrice(filter.priceMin, filter.priceMax, orders);
    }

    orders = stable(orders, sortByOrderNumber);
    const sorter = getSorterByField(sorting.field, sorting.isAsc);
    return stable(orders, sorter);
};
export const getOrdersFilteredSorted = {
    [ORDERS_TYPE_ALL]: createSelector([getFilter[ORDERS_TYPE_ALL], getSorting, getMySubjects, getOrderList[ORDERS_TYPE_ALL]], ordersFiltererSorter),
    [ORDERS_TYPE_FAVORITE]: createSelector([getFilter[ORDERS_TYPE_FAVORITE], getSorting, getMySubjects, getOrderList[ORDERS_TYPE_FAVORITE]], ordersFiltererSorter),
}



// WEBPACK FOOTER //
// ./src/store/ordersFind/selectors.js